export const IMGIX_S3_GCP_URL = process.env.REACT_APP_IMGIX_FUNDING_URL || '';
export const IMGIX_S3_URL = process.env.REACT_APP_IMGIX_URL || '';
